<template>
	<div class="anjian">
		<div v-wechat-title="$route.meta.title"></div>
		<Card class='card-left'>
			<Menu  ref="menus" theme="light" @on-select='menuItem' @on-open-change="openMenuItem" :active-name="menuName" :open-names="openMenuName">
				<Submenu :name="item.key" v-for="(item,index) in userInfo.menuList" :key="index">
					<template slot="title">
						<img :src="iconList[index]" class="menuIcon"/>
						<span style="font-weight: bold;">{{item.name}}</span>
					</template>
					<MenuItem :name="itemChild.key" v-for="(itemChild,indexTwo) in item.children" :key='indexTwo'>
						<span>{{itemChild.name}}</span>
						<div class="badge">
							<Badge v-if="itemChild.key == 'redistribution_client'" :count="userInfo.userNotice.clientRedistribution" overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
						<div class="badge">
							<Badge v-if="itemChild.key == 'myclient'" :count="userInfo.userNotice.clientUndeal" overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
					</MenuItem>
				</Submenu>
			</Menu>
		</Card>
		<div class='card-right-top'>
			<Card v-if="menuName == 'lock_customer_list'||menuName == 'customer_list_to_be_called_back'||menuName == 'all_client'||menuName == 'myclient'||menuName == 'redistribution_client'||menuName == 'client_search'" style="min-width: 1330px;">
				<Myclient @searchNameMenuItem="searchNameMenuItem" :needInitSearch="needInitSearch" :openMenuName="openMenuName[0]" :menuName="menuName" ref="Myclient"></Myclient>
			</Card>
			<Card v-if="menuName == 'team_lock_customer_list' || menuName == 'team_customer_list_to_be_called_back' || menuName == 'team_new_client'||  menuName == 'team_redistribution_client'|| menuName == 'team_all_client'" style="min-width: 1330px;">
				<TeamClient @searchNameMenuItem="searchNameMenuItem" :needInitSearch="needInitSearch" :openMenuName="openMenuName[0]" :menuName="menuName" ref="TeamClient"></TeamClient>
			</Card>
			<Card v-if="menuName == 'introduce'|| menuName == 'team_introduce'" style="min-width: 1330px;">
				<Introduce @searchNameMenuItem="searchNameMenuItem" :needInitSearch="needInitSearch" :openMenuName="openMenuName[0]" :menuName="menuName" ref="Myclient"></Introduce>
			</Card>
			<Card v-if="menuName == 'sign_management' || menuName == 'into_management'" style="min-width: 1330px;">
				<OnsiteCustomer  @searchNameMenuItem="searchNameMenuItem"  :needInitSearch="needInitSearch" :menuName="menuName" :openMenuName="openMenuName[0]"></OnsiteCustomer>
			</Card>
			<Card v-if="menuName == 'media_set' || menuName == 'client_sea'" style="min-width: 1330px;">
				<PublicPool @searchNameMenuItem="searchNameMenuItem" :needInitSearch="needInitSearch" :openMenuName="openMenuName[0]" :menuName="menuName"></PublicPool>
			</Card>
		</div>
	</div>
</template>

<script>
	import CustomClue from "./CustomClue";
	import Myclient from "./Myclient";
	import Introduce from "./Introduce";
	import TeamClient from "./TeamClient";
	import PublicPool from "./PublicPool.vue";
	import OnsiteCustomer from "./OnsiteCustomer";
	import SignUpIntoPieces from "./SignUpIntoPieces";
	import {mapGetters} from "vuex";
	import HistoryCustomer from "./HistoryCustomer";
	export default {
		name: "Client",
		components: {
			HistoryCustomer,
			CustomClue,
			OnsiteCustomer,
			SignUpIntoPieces,
			PublicPool,
			TeamClient,
			Myclient,
			Introduce,
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		created() {
			// 初始化菜单图标
			this.initIcon();
		},
		mounted: function() {
			let e = 'myclient';
			this.menuName = e;
		},
		data() {
			return {
				needInitSearch: true,
				menuName: '',
				openMenuName:['my_customer'],
				iconList: []
			}
		},
		methods: {
			searchNameMenuItem(menuName, openMenuName) {
				let that = this;
				if (menuName != '' && openMenuName != '') {
					this.needInitSearch = false;
					this.menuName = menuName;
					this.openMenuName = openMenuName;
					this.$nextTick(() => {
						that.$refs.menus.updateOpened();
						that.$refs.menus.updateActiveName();
					})
				} else {
					this.needInitSearch = true;
				}
			},
			menuItem(e) {
				this.menuName = e;
				this.needInitSearch = true;
			},
			redistributionNotFollow(){
				this.$router.push('/client')
			},
			initIcon() {
				let that = this
				this.userInfo.menuList.client.children.forEach(function (row, index) {
					that.iconList[index] = require('../../assets/icons/client/'+row.key+'.png');
				})
			},
			openMenuItem(e) {
				if(e.length > 0) {
					this.openMenuName = e
				}
				if(e[0] == 'my_customer'){
					this.menuName = 'myclient'
				}else if(e[0] == 'onsite_customer'){
					this.menuName = 'did_not_sign_up'
				}else if(e[0] == 'loan_customer'){
					this.menuName = 'underway'
				}else if(e[0] == 'history_customer'){
					this.menuName = 'history_customer_detail'
				}else if(e[0] == 'departmental_account_management'){
					this.menuName = 'team_new_client'
				}else if(e[0] == 'department_contract_management'){
					this.menuName = 'team_did_not_sign_up'
				}else if(e[0] == 'department_loan_management'){
					this.menuName = 'sign_management'
				}else if(e[0] == 'public_pool'){
					this.menuName = 'media_set'
				}
			}
		}
	}
</script>

<style scoped lang="less">
	/deep/ .top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 33px;
	}

	/deep/ .input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	/deep/ .top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}
/deep/ .ivu-menu-vertical .ivu-menu-submenu-title-icon{
transform: rotateZ(-90deg);
}
/deep/ .ivu-menu-vertical .ivu-menu-opened>*>.ivu-menu-submenu-title-icon{
// transform: rotate(90deg);
transform: rotateZ(0deg);
}

	/deep/ .cascader {
		width: 380px;
	}

	/deep/ .multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
			font-size: 12px;
		}
		span{
			font-size: 10px;
		}
	}

	/deep/ .chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	/deep/ .sousuo {
		height: 32px;
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 20px;
	}
	/deep/ .badge{
		position: absolute;
		width: 50px;
		height: auto;
		top: 30%;
		right: 10%;
	}
	.menuIcon{
		display: inline-block;
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-bottom: 3px;
		margin-right: 5px;
	}
</style>
